/* globals console, module, require, window */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    templates = require('../utilities/handlebars').templates,
    user = require('../models/user'),
    EOL = null;

module.exports = Marionette.View.extend({
    template: templates.header,
    tagName: 'div',
    attributes: {
        class: 'rts-header'
    },
    // events: {
    //     'dblclick img[name=logo]': 'onClickLogo'
    // },
    initialize: function () {
        this.templateContext = this.options || {};
        this.templateContext.roles = user.roles();
        this.listenTo(user, 'change:roles', _.bind(function () {
            this.templateContext.roles = user.roles();
            this.render();
        }, this));
    },
    // onClickLogo: function (event) {
    //     window.location = '#home';
    //     return false;
    // },
    mode: function (mode) {
        delete this.options.programs;
        delete this.options.dashboard;
        this.options[mode] = true;
        this.render();
    }
});
